<div class="align-left">
  <mat-slide-toggle [disabled]="!editMode" [(ngModel)]="boosterActive" (change)="changeBoosterActive($event)"
    >Booster active</mat-slide-toggle
  >
  <div [hidden]="!boosterActive" class="content-adjust">
    <span>Chance of winning: </span>
    <mat-form-field class="form-adjust">
      <input matInput [disabled]="!editMode" [(ngModel)]="chanceOfWinning" (change)="changeWinningChance($event)" />
    </mat-form-field>
  </div>
</div>
<app-nested-table-form-field
  [hidden]="!boosterActive"
  [editMode]="editMode"
  [fieldConfig]="fieldConfig"
  [data]="getData()"
  [formGroup]="formGroup"
  [fields]="fields"
  (valueChanged)="onValueChanged($event)"
  [canAdd]="canAdd"></app-nested-table-form-field>
